export default __webpack_public_path__ + "static/media/500.3caf1951.png";